import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGroup, IUserInfo } from 'types/user';

const initialState: IUserInfo = {
    id: '',
    type: '',
    attributes: {
        id: 0,
        email: '',
        role: 'admin',
        username: '',
        avatar: null,
        uid: '',
    },
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<IUserInfo>) => {
            return action.payload;
        },
        clearUser: () => {
            return initialState;
        },
        setAnonymousGroup: (state, action: PayloadAction<IGroup>) => {
            if (!state.attributes) {
                state.attributes = { ...initialState.attributes };
            }
            // Đã đăng nhập -> giữ group của tài khoản, không để survey ghi đè theme admin.
            if (state.attributes.id) {
                return;
            }
            const incoming = action.payload;
            const current = state.attributes.groups?.[0];
            // Trùng nội dung -> bỏ qua để không tạo reference mới (tránh re-render/nhấp nháy).
            if (
                current &&
                JSON.stringify(current) === JSON.stringify(incoming)
            ) {
                return;
            }
            // Ẩn danh, group khác -> cập nhật theo survey đang mở.
            state.attributes.groups = [incoming];
        },
    },
});

export const { setUser, clearUser, setAnonymousGroup } = userSlice.actions;

export default userSlice.reducer;
